import React from "react";
import { Typography, Stack, Grid, Box, styled } from "@mui/material";
import appleQrCode from "assets/img/appleQRCode.svg";
import androidQrCode from "assets/img/androidQRCode.svg";
import { ReactComponent as Round } from "assets/img/round.svg";
import { ReactComponent as AppStore } from "assets/img/appStore.svg";
import { ReactComponent as GooglePlay } from "assets/img/googlePlay.svg";
import { appsStoreNavigation } from "utilities";
import { STEPS_AFTER_ENROLLMENT } from "constants/enrollment";

const List = styled(Box)({
  display: "flex",
  padding: "0px 40px",
  textAlign: "left",
  marginBottom: 15,
  "& .stepsContainer svg": {
    display: "flex",
    alignItems: "flex-start",
    paddingTop: 15,
  },
  "& .step-text": {
    marginLeft: 5,
    fontWeight: 700,
  },
});

//Render steps
const renderStep = (step, index) => (
  <List key={index} className="stepsContainer">
    <Box>
      <Round />
    </Box>
    <Typography variant="h6" className="step-text">
      {step}
    </Typography>
  </List>
);

const EnrollmentSuccess = () => (
  <Stack sx={{ padding: "0px 8rem", textAlign: "center" }}>
    <Typography variant="h2" sx={{ color: "#0f172a" }}>
      Your account has successfully been created! Please scan the QR code to
      download the app.
    </Typography>

    <Grid container mt={5} gap={8} flexDirection={"column"}>
      <Grid item gap={3}>
        {STEPS_AFTER_ENROLLMENT.map(renderStep)}
      </Grid>
      {/* Store logo, QR code section */}
      <Grid container item flex={1} justifyContent={"center"} gap={8}>
        {/* Apple store and QR code section */}
        <Grid item flex={1} justifyContent={"center"} container gap={2}>
          <AppStore onClick={appsStoreNavigation} role="button" />
          <Typography variant="h6" pl={6} pr={6}>
            If you have an iPhone, please scan this QR code to download the app.
          </Typography>
          <img
            alt="QR code to download the KardiaComplete app"
            src={appleQrCode}
          />
        </Grid>

        {/* Google Play and QR code section */}
        <Grid item flex={1} justifyContent={"center"} container gap={2}>
          <GooglePlay onClick={appsStoreNavigation} role="button" />
          <Typography variant="h6" pl={6} pr={6}>
            If you have an Android, please scan this QR code to download the
            app.
          </Typography>
          <img
            alt="QR code to download the KardiaComplete app"
            src={androidQrCode}
          />
        </Grid>
      </Grid>

      {/* Email Note Section */}
      <Grid item container gap={2} flex={1}>
        <Typography>
          You will receive a confirmation email from support@alivecor.com
          confirming when your devices have shipped. If you have questions or
          concerns please feel free to reach out to our customer care team.
        </Typography>
      </Grid>
    </Grid>
  </Stack>
);

export default EnrollmentSuccess;
